<template
    ><div class="pa-5" v-if="activeClient && activeClient.codes">
        <div v-for="item in activeClient.codes" :key="item.code">
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Code" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.code ? item.code : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Partner" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.partner ? item.partner : "-" }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-item row-title" cols="3">{{ "Shop" | t }}</v-col>
                <v-col class="col-item" cols="6">
                    {{ item.shop_id ? getShopName(item.shop_id) : "-" }}
                </v-col>
            </v-row>
            <v-divider class="my-2" />
        </div></div
></template>

<script>
import { mapState } from "vuex";

export default {
    name: "client-codes-tab",
    computed: {
        ...mapState("ExportClientStore", ["activeClient"]),
        ...mapState(["shops"])
    },
    methods: {
        getShopName(shopId) {
            const shop = this.shops.find(s => s.id === shopId);
            return shop ? shop.name : "-";
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
